import { render } from "./ecogeste.vue?vue&type=template&id=759adea2&scoped=true"
import script from "./ecogeste.vue?vue&type=script&lang=js"
export * from "./ecogeste.vue?vue&type=script&lang=js"

import "./ecogeste.vue?vue&type=style&index=0&id=759adea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759adea2"]])

export default __exports__